/**
 * Locale-aware display helpers.
 *
 * Prefer the bound versions from useI18n() inside components - they already
 * carry the current language.
 *
 * Deliberately no money helper. Amounts are rendered from the backend's
 * `total_label`, which is the gross figure the customer is charged; the
 * `amount_cents` beside it is net, so formatting that instead would quietly
 * show the wrong number. Money therefore stays German-formatted in both
 * languages.
 */

import { intlLocale, type Lang } from "@/i18n/t";

export function formatDate(iso: string | null | undefined, lang: Lang): string {
  if (!iso) return "—";
  return new Intl.DateTimeFormat(intlLocale(lang), { dateStyle: "medium" }).format(new Date(iso));
}

export function formatDateTime(iso: string | null | undefined, lang: Lang): string {
  if (!iso) return "—";
  return new Intl.DateTimeFormat(intlLocale(lang), {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(iso));
}

/** Two-letter avatar label, e.g. "Anja Sommerfeld" -> "AS". */
export function initials(name: string | null | undefined): string {
  if (!name) return "—";
  const parts = name.split(/\s+/).filter(Boolean);
  return parts.map((p) => p[0]).join("").slice(0, 2).toUpperCase() || "—";
}
